export default {
  metadata: {
    version: '1.0.0',
    id: 'input-1.0.0',
    name: 'JDSInput'
  },
  hierarchy: {
    input: []
  },
  base: {
    input: {
      type: 'text',
      'text-align': '{i_0}',
      'placeholder-color': '{i_1}',
      'placeholder-font-family': '{i_2}',
      'placeholder-font-size': '{i_3}',
      'placeholder-line-height': '{i_5}',
      'placeholder-font-weight': '{i_4}',
      'input-color': '{i_7}',
      'input-font-family': '{i_8}',
      'input-font-size': '{i_9}',
      'input-line-height': '{i_11}',
      'input-font-weight': '{i_10}',
      'cursor-color': '{i_13}',
      disabled: false,
      width: '{i_14}'
    }
  },
  variant: {
    disabled: {
      true: {
        input: {
          opacity: '{i_15}',
          disabled: true
        }
      }
    },
    type: {
      email: {
        input: {
          type: 'email'
        }
      },
      number: {
        input: {
          type: 'number'
        }
      },
      password: {
        input: {
          type: 'password'
        }
      },
      textarea: {
        input: {
          type: 'textarea'
        }
      },
      pin: {
        input: {
          type: 'pin'
        }
      },
      phone: {
        input: {
          type: 'phone'
        }
      }
    },
    textAlign: {
      center: {
        input: {
          'text-align': '{i_16}'
        }
      },
      end: {
        input: {
          'text-align': '{i_17}'
        }
      },
      justify: {
        input: {
          'text-align': '{i_18}'
        }
      }
    },
    textSize: {
      large: {
        input: {
          'placeholder-font-family': '{i_19}',
          'placeholder-font-size': '{i_20}',
          'placeholder-line-height': '{i_21}',
          'placeholder-font-weight': '{i_22}',
          'input-font-family': '{i_23}',
          'input-font-size': '{i_24}',
          'input-line-height': '{i_25}',
          'input-font-weight': '{i_26}'
        }
      }
    }
  },
  api: {
    config: {
      disabled: {
        values: [false, true],
        doc_description: 'It can be used to enable or disable Input.'
      },
      type: {
        values: [
          'text',
          'email',
          'number',
          'password',
          'textarea',
          'pin',
          'phone'
        ],
        doc_description: 'This is used to specify the type of input.'
      },
      textAlign: {
        values: ['start', 'center', 'end', 'justify'],
        doc_description: 'It can be used to align text of the Input.'
      },
      textSize: {
        values: ['small', 'large']
      }
    },
    data: {
      input: {
        id: {
          type: 'string',
          name: 'id',
          platform: 'web'
        },
        value: {
          type: 'string',
          name: 'value'
        },
        placeholder: {
          type: 'string',
          name: 'placeholder'
        },
        'max-length': {
          type: 'number',
          name: 'maxLength'
        },
        pattern: {
          type: 'string',
          name: 'pattern'
        },
        rows: {
          type: 'number',
          name: 'rows'
        },
        name: {
          type: 'string',
          name: 'name'
        },
        min: {
          type: 'number',
          name: 'min'
        },
        'placeholder-letter-spacing': {
          type: 'double',
          name: 'letterSpacing',
          default: -0.5
        },
        'input-letter-spacing': {
          type: 'double',
          name: 'letterSpacing',
          default: -0.5
        },
        autoFocus: {
          type: 'boolean',
          name: 'autoFocus',
          platform: 'web'
        },
        max: {
          type: 'number',
          name: 'max'
        },
        required: {
          type: 'boolean',
          name: 'required'
        },
        focusRequester: {
          type: 'focusRequester',
          name: 'focusRequester',
          platform: 'android'
        },
        imeAction: {
          type: 'imeAction',
          name: 'imeAction',
          platform: 'android'
        },
        capitalization: {
          type: 'keyboardCapitalization',
          name: 'capitalization',
          platform: 'android'
        },
        semantics: {
          type: 'string',
          name: 'semantics',
          platform: 'android'
        }
      }
    },
    events: {
      input: {
        onFocus: 'onFocus',
        onBlur: 'onBlur',
        onChange: 'onChange',
        onSubmit: 'onSubmit',
        onKeyup: {
          name: 'onKeyup',
          platform: 'web'
        },
        onKeydown: {
          name: 'onKeydown',
          platform: 'web'
        },
        onPaste: 'onPaste',
        onInvalid: 'onInvalid'
      }
    },
    a11y: {
      input: {
        properties: {
          role: {
            value: 'input'
          },
          'aria-label': {
            name: 'ariaLabel'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-invalid': {
            name: 'ariaInvalid'
          },
          'aria-required': {
            name: 'ariaRequired',
            prop: 'required'
          },
          'aria-placeholder': {
            name: 'ariaPlaceholder',
            prop: 'placeholder'
          }
        }
      }
    }
  }
};
